import { useMemo } from 'react'
import cn from 'classnames'
import Countdown from 'react-countdown'

export default ({ date, textColor = 'text-white', className = '' }: any) => {
  const ONE_DAY = useMemo(() => 24 * 60 * 60 * 1000, [])
  const timeLeft = new Date(date).getTime() - new Date().getTime()

  const renderer = ({ days, hours, minutes, seconds }: any) => {
    const countdownBackgroundColor = timeLeft < ONE_DAY ? 'bg-white' : textColor
    const countdownTextColor = timeLeft < ONE_DAY ? 'text-red' : textColor

    return (
      <div
        className={cn(
          `flex items-center ${countdownBackgroundColor}`,
          className
        )}
      >
        <p
          suppressHydrationWarning
          className={`font-bold uppercase leading-5 ${countdownTextColor} text-15`}
        >
          {days} days {hours < 2 ? `0${hours}` : hours}:
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </p>
      </div>
    )
  }

  return <Countdown date={date} renderer={renderer} />
}
